import { useLang } from "../lib/i18n";
import { Languages } from "lucide-react";

export default function LangToggle() {
  const { lang, setLang } = useLang();
  return (
    <div
      className="inline-flex items-center neo-flat overflow-hidden text-xs font-bold"
      data-testid="lang-toggle"
    >
      <button
        type="button"
        onClick={() => setLang("en")}
        data-testid="lang-en"
        className={`px-2.5 py-1.5 transition-colors ${lang === "en" ? "text-white" : "text-slate-700"}`}
        style={{ background: lang === "en" ? "var(--pm-dog)" : "transparent" }}
      >
        ENG
      </button>
      <span className="text-slate-400">|</span>
      <button
        type="button"
        onClick={() => setLang("ar")}
        data-testid="lang-ar"
        className={`px-2.5 py-1.5 transition-colors ${lang === "ar" ? "text-white" : "text-slate-700"}`}
        style={{ background: lang === "ar" ? "var(--pm-dog)" : "transparent" }}
      >
        AR
      </button>
    </div>
  );
}
